import React from 'react'

import { usePathname } from 'next/navigation'

export const useIsFromPreNotice = (): boolean => {
  const pathname = usePathname()
  const [isFromPreNotice, setIsFromPreNotice] = React.useState(false)

  React.useEffect(() => {
    setIsFromPreNotice(pathname.includes('pre-notice'))
  }, [pathname])

  return isFromPreNotice
}
